import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, RecuperarAtendimentoIntegradorPPT } from './types';

export const INITIAL_STATE: RecuperarAtendimentoIntegradorPPT = {
	status: 0,
	data: null,
	messageError: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): RecuperarAtendimentoIntegradorPPT {
	return produce(state, draft => {
		switch (action.type) {
			case Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.messageError = INITIAL_STATE.messageError;
				break;
			}
			case Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.messageError = action.payload.message;
				break;
			}
			case Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.messageError = INITIAL_STATE.messageError;
				break;
			}

			default:
		}
		return draft;
	});
}
